export default __webpack_public_path__ + "static/media/product34.78a2237d.png";